import Vue from 'vue'
import Router from 'vue-router'
import Default from './containers/Default.vue'

import Gallery from './components/Gallery.vue'
import Configurator from './components/configurator/Configurator.vue'

import Imprint from './components/legal/Imprint.vue'
import PrivacyPolicy from './components/legal/PrivacyPolicy.vue'
import CookiePolicy from './components/legal/CookiePolicy.vue'
import TermsConditions from './components/legal/TermsConditions.vue'

import StartConfigurator from './components/StartConfigurator.vue'

import 'vuex'
import store from './store'

import scenarios from './assets/furnituresScenarios.json';

Vue.use(Router)

// export default new Router({
let router = new Router({
  mode: 'history',
  routes: [
    {
      path:'*',
      redirect:'/en'
    },
    {
      path: '/:lang',
      component: Default,
      children:[
        {
          path: '/',
          name: 'Home',
          component: Gallery
        },
        {
          path:'hannover',
          component: StartConfigurator
        },
        {
          path:'imprint',
          component: Imprint,
          name: 'Imprint',
          children:[
            {
              path:'/imprint/de',
              component: Imprint
            }
          ]
        },
        {
          path:'privacy-policy',
          component: PrivacyPolicy,
          name: 'PrivacyPolicy',
          children:[
            {
              path:'/privacy-policy/de',
              component: PrivacyPolicy
            }
          ]
        },
        {
          path:'cookie-policy',
          component: CookiePolicy,
          name: 'CookiePolicy',
          children:[
            {
              path:'/cookie-policy/de',
              component: CookiePolicy
            }
          ]
        },
        {
          path:'conditions-of-use',
          component: TermsConditions,
          name: 'TermsConditions',
          children:[
            {
              path:'/conditions-of-use/de',
              component: TermsConditions
            }
          ]
        },
        {
          path:'configurator',
          component: Configurator,
          children:[
            {
              path:':id',
              component: Configurator,
              beforeEnter: (to, from, next) => {
                if(scenarios.find(o => o.url === to.params.id)) next()
                else next('/')
              }
            }
          ]
        }
      ]
    }
  ]
})

// use beforeEach route guard to set the language
router.beforeEach((to, from, next) => {

  // use the language from the routing param or default language
  let language = to.params.lang;
  if (!language) {
    language = 'en';
    to.params.lang = 'en';
    store.dispatch('setLanguage',language);
    next();
  }
  else if (language !== 'en' && language != 'de' && language){
    language = 'en';
    store.dispatch('setLanguage',language);
    next('/');
  }
  else{
    store.dispatch('setLanguage',language);
    next();
  }

});

export default router
